import React from 'react'
import { Link } from 'react-router-dom'
import logoBig from '../images/footer-logo.svg';
import logo2 from '../images/logo-white.svg';
import linkedin from '../images/icon-linkedin.svg';
import twitter from '../images/icon-twitter.svg';
// import facebook from '../images/icon-facebook.svg';

const Footer = () => (
  <footer className="overflow" id="foo">
    <div className="stech">
      <img src={logoBig} title="Stech" alt="Stech" />
    </div>

    <div className="contact-bar">
      <div className="container">
        <Link to="/contact">
          If you're ready, contact our team to find out more →
        </Link>
      </div>
    </div>
    <div className="container">
      <Link to="/" className="logo">
        <img src={logo2} title="Stech" alt="Stech" />
      </Link>
    </div>
    <div className="container clearfix">
      <div className="left">
        <nav className="clearfix">
          <ul>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/partners">Our Partners</Link>
            </li>
            <li>
              <Link to="/products">Products</Link>
            </li>
            <li>
              <Link to="/news">News</Link>
            </li>
            <li>
              <Link to="/careers">Careers</Link>
            </li>
            <li>
              <Link to="/affiliate">Affiliate</Link>
            </li>
            <li>
              <Link to="/contact">Get in Touch</Link>
            </li>
          </ul>
        </nav>
      </div>
      <div className="right">
        <div className="social-media">
          <a
            href="https://www.linkedin.com/company/stechcom"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={linkedin} title="Linkedin" alt="Linkedin" />
          </a>
          <a
            href="https://twitter.com/STechTechnology"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={twitter} title="Twitter" alt="Twitter" />
          </a>
          {/* <a href="https://www.facebook.com/"><img src={facebook} title="Facebook" alt="Facebook" /></a> */}
        </div>
      </div>
    </div>
    <div className="container clearfix">
      <div className="tc clearfix">
        <ul>
          <li>
            <Link to="/termsConditions">Terms &amp; Conditions</Link>
          </li>
          <li>
            <Link to="/cookies">Cookies</Link>
          </li>
          <li>
            <Link to="/privacypolicy">Privacy Policy</Link>
          </li>
        </ul>
      </div>
      <div className="copyright">
        {new Date().getFullYear()} Copyright STech
      </div>
    </div>
  </footer>
);

export default Footer
